import Typography from "@mui/material/Typography";
import type { FC } from "react";

export const BrandMark: FC = () => (
  <Typography
    variant="subtitle1"
    sx={{
      fontWeight: 700,
      color: "text.primary",
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
    }}
  >
    Opensource.clinic
  </Typography>
);
